export function clamp(v: number, min: number, max: number): number {
  return Math.min(Math.max(min, v), max);
}

export function minMax(a: number, b: number): [number, number] {
  return [Math.min(a, b), Math.max(a, b)];
}
